import { concat } from '@ember/helper';
import Component from '@glimmer/component';

import type { IconColor, IconSize } from '../../types/components/prism/icon.ts';
import { uniqueId } from '../../utils/unique-id.ts';
import { COLOR_CLASS_MAP, SIZE_CLASS_MAP } from './icon.gts';
import styles from './loading-spinner.module.css';

interface PrismLoadingSpinnerSignature {
  Args: {
    color?: IconColor;
    size?: IconSize;
  };
  Element: SVGElement;
}

export default class PrismLoadingSpinner extends Component<PrismLoadingSpinnerSignature> {
  id = uniqueId();

  get classesForContainer(): string {
    const { color, size } = this.args;

    const classes = [
      styles.container,
      COLOR_CLASS_MAP[color ?? 'default'],
      SIZE_CLASS_MAP[size ?? 'medium'],
    ];

    return classes.join(' ');
  }

  <template>
    {{#let
      (concat "spinner-firstHalf-" this.id)
      (concat "spinner-secondHalf-" this.id)
      as |spinnerId1 spinnerId2|
    }}
      <svg
        aria-hidden="true"
        class={{this.classesForContainer}}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        ...attributes
      >
        <defs>
          <linearGradient id={{spinnerId2}}>
            <stop offset="0%" stop-color="currentColor" stop-opacity="0" />
            <stop offset="100%" stop-color="currentColor" stop-opacity="0.7" />
          </linearGradient>
          <linearGradient id={{spinnerId1}}>
            <stop offset="0%" stop-color="currentColor" stop-opacity="1" />
            <stop offset="100%" stop-color="currentColor" stop-opacity="0.7" />
          </linearGradient>
        </defs>

        <g stroke-width="2">
          <path
            d="M 1 12 A 4.5 4.5 0 0 1 23 12"
            fill="transparent"
            stroke="url(#{{spinnerId2}})"
          />
          <path
            d="M 23 12 A 4.5 4.5 0 0 1 1 12"
            fill="transparent"
            stroke="url(#{{spinnerId1}})"
          />
        </g>
      </svg>
    {{/let}}
  </template>
}
